export const accounts= [
    {
        username: 'admin',
        email:'admin@gmail.com',
        avatar: 'https://i.pinimg.com/564x/65/d6/c4/65d6c4b0cc9e85a631cf2905a881b7f0.jpg',
        password: '123'
    }
]